module.exports = __webpack_public_path__ + "img/double-arrow.84bbe0b2.svg";